import { create } from "zustand";

interface IGreetingStore {
  showGreeting: boolean;
  setShowGreeting: (showGreeting: boolean) => void;
}

export const useGreetingStore = create<IGreetingStore>((set) => ({
  showGreeting: false,
  setShowGreeting: (showGreeting) => set({ showGreeting }),
}));
